import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import {
  OIAnyDepreciationSection57Form,
  OIAnyIncomeFromInvoiceDiscountingForm,
  OIAnyIncomeFromNonNotifiedCountryForm,
  OIAnyIncomeFromOnlineGamingForm,
  OIAnyIncomeFromOtherForm,
  OIAnyIncomeSection89AForm,
  OIAnyIncomeTaxablePreYear89AForm,
  OIAnyTaxationReliefUS89AForm
} from "..";
import { IOtherIncomes } from "../../../../config/interfaces";
import { OtherIncomesFormInitValues } from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
  showCanvas: boolean;
  formValues: IOtherIncomes | null;
  handleCloseBtnPress: (salaryData: IOtherIncomes | null) => void;
};

const OIAnyOtherIncomeDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IOtherIncomes>(OtherIncomesFormInitValues);

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(OtherIncomesFormInitValues));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          onSubmit={(values) => handleCloseBtnPress(values)}
        >
          {({ handleSubmit, submitCount, isValid, errors }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Other Income details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <OIAnyIncomeFromOnlineGamingForm />
                <OIAnyIncomeFromInvoiceDiscountingForm />
                <OIAnyIncomeFromOtherForm />
                <OIAnyDepreciationSection57Form />
                <OIAnyIncomeSection89AForm />
                {/* Income claimed for taxation relief u/s 89A */}
                <OIAnyTaxationReliefUS89AForm />
                {/* Income from retirement benefits account maintained in a non-notified country */}
                <OIAnyIncomeFromNonNotifiedCountryForm />
                {/* Income taxable during the previous year on which relief u/s 89A was claimed */}
                <OIAnyIncomeTaxablePreYear89AForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button variant="outline-white" size="sm" onClick={() => handleSubmit()}>
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default OIAnyOtherIncomeDetailsForm;
